import axios from 'axios';
import qs from 'query-string';

class Request {
  constructor(params = false, config) {
    const self = this;
    this.apiUrl = (process.env.NODE_ENV === 'production')
      ? config.build.BACKEND_URL
      : config.dev.BACKEND_URL + '/api';
    this.tokenUri = '/user/sign_in/token';
    this.response = null;
    this.retrieve = false;
    this.storage = localStorage;
    this.req = null;
    this.passphrase = localStorage.getItem('passphrase');
    this.token = localStorage.getItem('token');

    if (params) {
      this.params = params;
    }

    if (this.token !== null) {
      this.req = axios.create({
        baseUrl: this.apiUrl,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.token}`,
          Accept: 'application/json',
        },
        responseType: 'json',
        xsrfCookieName: null,
        xsrfHeaderName: null,
      });
    } else {
      this.req = axios.create({
        baseUrl: this.apiUrl,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        responseType: 'json',
        xsrfCookieName: null,
        xsrfHeaderName: null,
      });
    }

    this.req.interceptors.response.use(response => response, (error) => {
      if (error.response) {
        const originalRequest = error.config;
        if (!(this.token === 'undefined' ||
          this.token === null)) {
          if (error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            self.retrieve = true;
            const tokenRequest = axios.create({
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              responseType: 'json',
              xsrfCookieName: null,
              xsrfHeaderName: null,
            });

            return tokenRequest.post(self.apiUrl + self.tokenUri, {
              passphrase: this.passphrase,
            }).then((response) => {
              const token = response.data.token.jwt;
              self.storage.setItem('token', token);
              self.token = token;
              axios.defaults.headers.common.Authorization = `Bearer ${token}`;
              originalRequest.headers.Authorization = `Bearer ${token}`;
              self.retrieve = true;
              return axios(originalRequest);
            }).catch(() => {
              localStorage.removeItem('passphrase');
              localStorage.removeItem('token');
              localStorage.removeItem('user_id');
              localStorage.removeItem('passphrase_id');
              self.passphrase = null;
              self.token = null;
              location.reload();
            });
          } else if (error.response.status === 404 && !originalRequest._retry) {
            return Promise.reject(error);
          }
        } else {
          return Promise.reject(error);
        }
      } else if (error.message === 'Network Error') {
        return Promise.reject(error);
      }
      return Promise.reject(error);
    });
  }

  get(uri, params = false) {
    uri = (params === false) ? this.apiUrl + uri :
      this.apiUrl + uri + `?${qs.stringify(params, {arrayFormat: 'bracket'})}`;

    return this.req.get(uri);
  }

  post(uri, data) {
    return this.req.post(this.apiUrl + uri, data);
  }

  put(uri, data) {
    return this.req.put(this.apiUrl + uri, data);
  }

  patch(uri, data) {
    return this.req.patch(this.apiUrl + uri, data);
  }

  delete(uri, data = false) {
    if (!data) {
      return this.req.delete(this.apiUrl + uri);
    }
    return this.req.delete(this.apiUrl + uri, data);
  }

  successHandler(res) {
    return {
      data: res.data,
      code: res.status
    }
  }
}

export default Request;



// WEBPACK FOOTER //
// ./src/helper/request.js